.root > [data-scrollable] {
  max-height: 200px;
  overflow-y: auto;
}

.control {
  border-radius: var(--mantine-radius-sm);
  border-bottom: 1px solid var(--mantine-color-gray-2);
}

.control[data-active="true"] {
  background: var(--mantine-color-ice-0);
}
